module.exports = __webpack_public_path__ + "img/ST0047.98dbb11.webp";